// extracted by mini-css-extract-plugin
export var safetyBanner = "safetyBanner__Usap";